/**
 * 
 * LRWrapper.js
 * 
 */

 import React, { Component } from 'react'
import { Container, Row, Col } from 'react-bootstrap';

 
 export default class LRWrapper extends Component {

    static displayName = LRWrapper.name;



     render() {



         return (
            
            <Container id={this.props.id} style={{ backgroundColor: '', paddingTop: '240px', paddingBottom: '120px', backgroundRepeat: "no-repeat", backgroundSize: "150% 100%" }} >
                
                <Row className="h-50">
                    
                    <Col sm={8} style={{backgroundColor: '' }}>
                        { this.props.children[0] }
                    </Col>

                    <Col lg={4} style={{ backgroundColor: '' }}>
                        { this.props.children[1] }
                    </Col>
                
                </Row>

            </Container>

         );


     }


 }
 

 
